module.exports = __webpack_public_path__ + "static/media/gam.e8703e63.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/gam.svg
// module id = 1212
// module chunks = 0